export default __webpack_public_path__ + "static/media/yen-3-adverts.ab87ac3a.jpg";